import { UserInfoReponse } from '@app/core/models/claim.model';

export class SetSalesPersonId {
  public static readonly type = '[User] Set Sales PersonId';
}

export class SetUserInfo {
  static readonly type = '[Auth] Set user info';
  constructor(public userInfo: UserInfoReponse) {}
}

export class ResetUserInfo {
  static readonly type = '[Auth] Reset user info';
}
